
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div class="row">


  <div class="Column-new colmd3" *ngIf="ShowList">

    <div class="card ms-office-card padding-left-5px padding-right-5px height-100pe">

      <div class="card-header ms-sidebar-header-box padding-right-32px padding-bottom-3px">
        <div class="row margin-top10px nav-link-hand">


          <label class="ms-sidebar-header-title">
            <i class="far fa-calendar-check margin-right-6px"></i> Book Appointments
          </label>



        </div>
        <div class="row margin-top10px ">

          <label class="wh-header font-weight-normal labcolor border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-sky"
                 hidden>
            Doctors
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">
        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px">
          <!--<input type="search" class="form-control padding-bottom-2px width-230px" placeholder="Search....">-->
          <div class="col-md-12 padding-left-0px">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
          </div>


        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper scroll padding-lrt ">
            <div *ngIf="isRequesting">

              <div class="loader-text">
                <div class="loader-text2">

                  <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div class="margin-top-20px margin-left-5px">
                    <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                  </div>
                  <!--Loading Please Wait...-->
                </div>
              </div>


            </div>
            <div *ngIf="!isRequesting">
              <div class="row rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px"
                   *ngFor="let l of pdata" (click)="DoctorListItemSelected(l)">
                <div class="col-md-12 margin-top-5px margin-bottom-5px">

                  <div class="row">
                    <div class="col-md-3">
                      <div class="row">
                        <a class="nav-link-hand margin-left-5px">
                          <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                        </a>
                      </div>
                    </div>
                    <div class="col-md-9 padding-left-0px">
                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px f2 td-elipsis-appoinment1">{{l.Prefix}}{{l.DisplayName}}</label>
                      </div>

                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px font-size-11px">{{l.Specialty}}</label>
                      </div>

                    </div>

                  </div>






                </div>
              </div>
            </div>
            <!--<div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="DR SITARAM.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Sitharam</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Cardiologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-3">
                    <div class="row">
                      <a class="nav-link-hand margin-left-5px" (click)="viewservice()">
                        <img class="user-image-circle-65px img2" src="N.Tesla.jpg">
                      </a>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row a1">
                      <label class="margin-bottom-0px f2">Dr.Tesla</label>
                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3">Neurologist</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>-->



          </div>
        </div>

      </div>

    </div>
  </div>




  <div class="column2" *ngIf="SelectedDoctor">

    <div class="card height-100pe">

      <!--<div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
        </div>
      </div>-->

      <div class="card-header background-white pad5">
        <div class="row">
          <div class="col-md-1 margin-left-40px">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img3" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">{{SelectedDoctorData.DisplayName}}</label>
            </div>
            <!--<div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>-->
            <div class="row a1">
              <label class="margin-bottom-0px f3">{{SelectedDoctorData.Specialty}}</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3 color-Assign">{{BranchName}}</label>
            </div>
          </div>
          <div class=" offset-md-3 col-md-4 col-sm-3 padding-right padding-left-0px margin-top-auto margin-bottom-auto margin-left-auto">
            <div class="form-group  margin-bottom-5px">
              <div class="row">
                <div class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="DecrementDate()">
                  <a title="Previous" class="nav-link-hand">
                    <i class="fas fa-caret-left margin-top-3px  font-size-24px"></i>
                  </a>
                </div>

                <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                  <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                </div>-->

                <div class="col-md-7 col-sm-4 padding-l-0px padding-right-9px">
                  <div class="date-form">
                    <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                           (ngModelChange)="dataChanged($event)">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon font-size-16px top-11px "><i class="far fa-calendar-alt data-color-new"></i></span>

                    </a>

                  </div>



                </div>
                <div class="col-md-1  margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover" (click)="IncrementDate()">
                  <a title="Next" class="nav-link-hand">
                    <i class="fas fa-caret-right margin-top-3px  font-size-24px "></i>
                  </a>
                </div>

              </div>

            </div>
          </div>
        </div>


      </div>

      <div class="card-body background-white padding-top-5px">
        <div class=" padding-lrt ">

          <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">
            <div class="row" *ngIf='PresentDate && DisplayPresentDate'>
              <div class="col-md-11 padding-left-30px label">
                <label class="font-size-14 label label-color-kn">Available / Filled Slots as on </label>
                <label class="font-size-14 label label-color-kn font-weight-bold margin-left-3px">{{PresentDate| date:'dd-MMM-yyyy'}}</label>
              </div>


            </div>
            <!--<div class="row" *ngIf='PresentDate && DisplayPresentDate'>
              <div class="col-md-11 padding-left-30px label">
                <label class="font-size-14 label label-color-kn">Available / Filled Slots as on {{PresentDate| date:'dd-MMM-yyyy'}}</label>

              </div>


            </div>-->
            <div class="row" *ngIf='DateSelected && DisplaySelectedDate'>
              <div class="col-md-11 padding-left-30px label">
                <label class="font-size-14 label label-color-kn">Available / Filled Slots as on </label>
                <label class="font-size-14 label label-color-kn font-weight-bold margin-left-3px">{{DateSelected| date:'dd-MMM-yyyy'}}</label>
              </div>


            </div>
            <div class="row" *ngIf='ChangedDate && DisplayChangedDate'>
              <div class="col-md-11 padding-left-30px label">
                <label class="font-size-14 label label-color-kn">Available / Filled Slots as on </label>
                <label class="font-size-14 label label-color-kn font-weight-bold margin-left-3px">{{ChangedDate| date:'dd-MMM-yyyy'}}</label>
              </div>


            </div>
            <div class="row margin-right-0px">

              <div class="col-md-12" *ngIf="ProviderSlots">
                <div class="card ">

                  <div class="card-body padding-bottom-10px">
                    <div class="row">
                      <!--<div class="offset-md-1 col-md-2">

                        <div class="row">

                          <label class="margin-bottom-0px f2">Today</label>

                        </div>

                        <div class="row" *ngIf="SelectedFromDate" >

                          <a class="nav-link-hand" (click)="applist1()"><label class="margin-bottom-0px f2">{{SelectedFromDate| date:'dd-MMM-yyyy'}}</label></a>

                        </div>



                      </div>-->
                      <div class="col-md-12">
                        <div class="row">
                          <div *ngFor="let p of ProviderSlots" class="col-md-3">
                            <div class="col-md-3">
                              <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p4-new border-color-light"
                                      *ngIf="p.AppointmentCode <= 0"
                                      (click)="regpatientmodal(p)"
                                      type="button">
                                {{p.StartDate | date: 'hh:mm a'}}
                              </button>
                              <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p4-new border-color-light"
                                      *ngIf="p.AppointmentCode > 0"
                                      (click)="regpatientmodal(p)"
                                      type="button">
                                {{p.StartDate | date: 'hh:mm a'}}
                              </button>
                              <!--<button class="btn btn-outline-secondary hover1 c2 nav-link-hand p4-new border-color-light" *ngIf="p.AppointmentCode > 0"
                                      [disabled]="p.IsActive"
                                      type="button">
                                {{p.StartDate | date: 'hh:mm a'}}
                              </button>-->
                              <!--<label class=" btn btn-outline-secondary hover1 c2-confirmed p4-booked border-color-light"
         *ngIf="p.AppointmentCode > 0">{{p.StartDate | date: 'hh:mm a'}}</label>-->
                            </div>
                          </div>
                          <!--(click)="regpatientmodal(p)"
                              <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="regpatientmodal()" type="button">10:00</button>
                          </div>-->
                          <!--<div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">11:00</button>

                          </div>-->



                        </div>

                        <!--<div class="row">
                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">10:15</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">11:15</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">12:15</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">1:15</button>
                          </div>

                        </div>

                        <div class="row">
                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">10:30</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">11:30</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">12:30</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">1:30</button>
                          </div>

                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">10:45</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">11:45</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">12:45</button>
                          </div>

                          <div class="col-md-3">
                            <button class="btn btn-outline-secondary hover1 c2 nav-link-hand p3" (click)="Patient()" type="button">1:45</button>
                          </div>

                        </div>-->

                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>



          </div>


        </div>

      </div>
    </div>

  </div>

  <div class="column4" *ngIf="ShowList2"></div>

  <div class="column5 margin-top-16px colmd3" *ngIf="ShowList1">
    <div class="card height-100pe">

      <div class="card-header wh-header header3 padding-left-30px padding-right-32px bk-color-sky padding-bottom-0px padding-top-5px">
        <div class="row nav-link-hand">

          <label class="font-size-16px labcolor padding-bottom-0px margin-bottom-0px bk-color-sky font-size-14">
            Appointments of the day
          </label>


        </div>
        <div class="row nav-link-hand">

          <label class="wh-header labcolor font-weight-normal border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky font-size-14" *ngIf='PresentDate && DisplayPresentDate'>
            {{PresentDate| date:'dd-MMM-yyyy'}}
          </label>

          <label class="wh-header labcolor font-weight-normal border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky font-size-14" *ngIf='DateSelected && DisplaySelectedDate'>
            {{DateSelected| date:'dd-MMM-yyyy'}}
          </label>
          <label class="wh-header labcolor font-weight-normal border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky font-size-14" *ngIf='ChangedDate && DisplayChangedDate'>
            {{ChangedDate| date:'dd-MMM-yyyy'}}
          </label>
        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">

        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px padding-left-10px">
          <div class="col-md-12 padding-left-0px">
            <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange1($event)"></search-list>
          </div>



        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-569 agreement-chart-wrapper scroll padding-lrt ">
            <div *ngIf="isLoading">

              <div class="loader-text">
                <div class="loader-text2">

                  <div class="lds-facebook">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <div class="margin-top-20px margin-left-5px">
                    <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                  </div>
                  <!--Loading Please Wait...-->
                </div>
              </div>


            </div>
            <div *ngIf="!isLoading">
              <div class="table-component b1" *ngIf="CurrentDoctorAppointmentsByDoctorcodeController">
                <div class="table-responsive overflow-x">


                  <table class="table table-striped margin-left-zero"
                         cols="auto,2*,*,*,*,*,*,*">

                    <tbody class="table-body">
                      <!--<div *ngFor="let l of CurrentDoctorAppointmentsByDoctorcodeController"
            >-->
                      <tr class="hover-table-row" *ngFor="let l of pdata1" (click)="AppointmentsListItemSelected(l)">
                        <td class="padding-top-0px padding-bottom-0px">
                          <div class="row">
                            <div class="col-md-10 margin-top-5px margin-bottom-5px  padding-left-7px">

                              <div class="row ">
                                <div class="col-md-2  padding-left-27px">
                                  <div class="row">

                                    <img class="user-image-circle-65px img2" [src]="l.PatientImageFile" onError="this.src='dummy.jpg';">

                                  </div>

                                </div>
                                <div class="col-md-7">
                                  <div class="row ">
                                    <div class="col-md-12">
                                      <label class="margin-bottom-0px font-size-12px font-weight-600 td-elipsis-appoinment margin-top-3px">{{l.PatientName}}</label>
                                    </div>



                                  </div>

                                  <div class="row a1">

                                    <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> {{l.Telephone1}}</label>


                                  </div>



                                </div>
                                <div class="col-md-3 padding-left-0px padding-right-0px">
                                  <div class="row a1">
                                    <div class="col-md-12 padding-right-7px">
                                      <label class="margin-bottom-0px font-size-14px padding-top-4px">{{l.AppointmentDate | date: 'hh:mm a'}}</label>
                                    </div>


                                  </div>

                                  <div class="row float-right" *ngIf="l.AppointmentStatus=='Pending'">
                                    <button type="button" (click)="cancel()" class="btn btn-secondary font-size-10px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right padding-top-1px padding-bottom-1px padding-left-2px padding-right-2px"><i class="fa fa-times color-Rejected margin-right-3px"></i>Cancel</button>

                                  </div>










                                </div>

                              </div>


                            </div>
                            <div class="col-md-2">
                              <div class="float-right margin-top-14p" [ngSwitch]="l.AppointmentStatus">


                                <a data-toggle="tooltip" data-placement="bottom" title="Pending">

                                  <i *ngSwitchCase="'Pending'"
                                     class="fas fa-circle gray nav-link-hand font-size-14">
                                  </i>
                                </a>

                                <a data-toggle="tooltip" data-placement="bottom" title="Checked In">
                                  <i *ngSwitchCase="'CHECKIN'"
                                     class="fas fa-circle color-Checkin nav-link-hand font-size-14">
                                  </i>
                                </a>
                                <a data-toggle="tooltip" data-placement="bottom" title="Enc Start">
                                  <i *ngSwitchCase="'ENCSTART'"
                                     class="fas fa-circle color-Assign nav-link-hand font-size-14">
                                  </i>
                                </a>
                                <a data-toggle="tooltip" data-placement="bottom" title="Enc End">
                                  <i *ngSwitchCase="'ENCEND'"
                                     class="fas fa-circle color-Encend nav-link-hand font-size-14">
                                  </i>
                                </a>
                                <a data-toggle="tooltip" data-placement="bottom" title="Checked Out">
                                  <i *ngSwitchCase="'CHECKOUT'"
                                     class="fas fa-circle color-checkout  nav-link-hand font-size-14">
                                  </i>
                                </a>
                                <a data-toggle="tooltip" data-placement="bottom" title="No Show">
                                  <i *ngSwitchCase="'NOSHOW'"
                                     class="fas fa-circle color-Rejected  nav-link-hand font-size-14">
                                  </i>
                                </a>




                                <a data-toggle="tooltip" data-placement="bottom" title="Pending">
                                  <i *ngSwitchDefault
                                     class="fas fa-circle color-cyan nav-link-hand font-size-14">
                                  </i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>

                    </tbody>

                  </table>
                </div>
              </div>
              </div>
              <!--<div class="row rowfor margin-left-0px margin-right-0px  edit_hover_class" hidden>
      <div class="col-md-12 margin-top-5px margin-bottom-5px">

        <div class="row">
          <div class="col-md-2 padding-top-5px padding-left-25px">
            <div class="row">

              <img class="user-image-circle-65px img2" src="Thor.jpg">

            </div>

          </div>
          <div class="col-md-7">
            <div class="row a1">

              <label class="margin-bottom-0px f2">B.Vikram</label>


            </div>

            <div class="row a1">
              <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
            </div>



          </div>
          <div class="col-md-3">
            <div class="row a1">

              <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

            </div>

          </div>

        </div>

        <div class="row">
          <div class="offset-md-8 col-md-4">
            <div class="row">
              <div class="col-md-4">
                <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14"></i></a>
              </div>
              <div class="col-md-4">
                <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14"></i></a>
              </div>
              <div class="col-md-4">
                <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14"></i></a>
              </div>
            </div>
          </div>
        </div>




      </div>

    </div>-->



            </div>
          </div>

      </div>

    </div>
  </div>



  <div class="column3" *ngIf="AppList">
    <div class="card">

      <div class="card-header wh-header header3 padding-left-30px padding-right-32px bk-color-sky padding-bottom-0px">
        <div class="row nav-link-hand">

          <label class="font-size-16px labcolor padding-bottom-0px margin-bottom-0px bk-color-sky">
            Appointments of the day
          </label>


        </div>
        <div class="row nav-link-hand">

          <label class="wh-header labcolor font-weight-normal border-radius-4px padding-bottom-0px margin-bottom-0px bk-color-sky">
            25 May 2019
          </label>


        </div>

      </div>
      <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-sky">

        <div class="row padding-top-5px padding-bottom-10px margin-right-0px margin-left-5px padding-left-10px">
          <input type="search" class="form-control padding-bottom-2px width-271px" placeholder="Search....">


        </div>
        <div>
          <div class="chatsd product-chart-wrapper product-chat-height-569 agreement-chart-wrapper ps2 padding-lrt ">
            <div class="row rowfor margin-left-0px margin-right-0px   edit_hover_class">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>



                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>

                <div class="row">
                  <div class="offset-md-8 col-md-4">
                    <div class="row">
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-4">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>
                  </div>
                </div>




              </div>

            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Thor.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">B.Vikram</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row rowfor margin-left-0px margin-right-0px">
              <div class="col-md-12 margin-top-5px margin-bottom-5px">

                <div class="row  edit_hover_class">
                  <div class="col-md-2 padding-top-5px padding-left-25px">
                    <div class="row">

                      <img class="user-image-circle-65px img2" src="Tony Stark.jpg">

                    </div>

                  </div>
                  <div class="col-md-7">
                    <div class="row a1">

                      <label class="margin-bottom-0px f2">T.Stark</label>


                    </div>

                    <div class="row a1">
                      <label class="margin-bottom-0px f3"><i class="fas fa-phone"></i> 8801667136</label>
                    </div>
                    <div class="row">
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Details"><i class="fas fa-list font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Message"><i class="fas fa-envelope font-size-14px"></i></a>
                      </div>
                      <div class="col-md-3">
                        <a class="nav-link-hand" data-toggle="tooltip" data-placement="bottom" title="Cancel"><i class="fas fa-times font-size-14px"></i></a>
                      </div>
                    </div>

                  </div>

                  <div class="col-md-3">
                    <div class="row a1">

                      <label class="margin-bottom-0px font-size-14px padding-top-4px">10:00 A.M</label>

                    </div>

                  </div>


                </div>






              </div>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>



</div>






<div class="row" *ngIf="User">
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card input-style">
      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
        </div>
      </div>
      <div class="card-body background-white">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">
          <div class="row">
            <div class="offset-md-2 col-md-5 col-xl-5 margin-right-0px">
              <div class="row margin-top-30px">
                <label class="font-size-18px margin-left-14px margin-top-10">Please Select type of Patient</label>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="offset-md-2 col-md-9 col-xl-9 margin-right-0px margin-top-30px">

              <label class="radio-inline margin-right-30px">

                Registered patient <a class="nav-link-hand margin-left-5px" (click)="regpatientmodal()"> <input type="radio"> </a>
              </label>
              <label class="radio-inline margin-left-35px ">
                Guest/New patient <a class="nav-link-hand margin-left-5px" (click)="guestpatient()"> <input type="radio"> </a>
              </label>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>


<div class="row margin-top-15px margin-right-0px" *ngIf="PatientDetails">
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card">

      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
        </div>
      </div>

      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="offset-md-1 col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>
          <div class="col-md-3">
            <div class="row">
              <label class="margin-bottom-0px f2">Appointment</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">24-May-2019</label>
            </div>
            <div class="row">
              <label class="margin-bottom-0px">11:15 A.M</label>
            </div>

          </div>

        </div>


      </div>

      <div class="card-body background-white  padding-left-0px padding-top-0px">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px b2 margin-bottom-10px">

          <div class="row">


            <div class="offset-md-3 col-md-9 margin-bottom-20px">

              <div class="row">
                <label class="font-size-20px margin-bottom-5px margin-top-10">Patient Details</label>
              </div>
              <div class="row my-pro-form margin-t-form">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Name </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Name">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Phone Number </label>
                    </div>
                    <div class="col-md-6">

                      <input type="tel" class="form-control form-control-patient font-size-20px" mask="(000-000-0000)" placeholder="Phone Number">
                      <!--<small class="form-text text-danger"
                             *ngIf="(!Telephone1.valid)">(Provide Valid CellNo)</small>-->


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Email </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Email">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Age </label>
                    </div>
                    <div class="col-md-6">

                      <input type="text" class="form-control form-control-patient font-size-20px" placeholder="Age">


                    </div>


                  </div>

                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
                  <div class="row">
                    <div class="col-md-3 text-align-right">
                      <label class="lab-size1"> Sex </label>
                    </div>
                    <div class="col-md-6">

                      <label>
                        <select class="form-control form-control-patient font-size-20px">
                          <option> </option>
                          <option>Male</option>
                          <option>Female</option>
                        </select>
                      </label>



                    </div>


                  </div>

                </div>
              </div>























            </div>



          </div>

        </div>
        <div class="row margin-top-15px margin-top-30px margin-bottom-30px">

          <div class="col-md-10">
            <button class="btn bs hover1 nav-link-hand font-size-16px width float-right" (click)="BacktoList()" type="button">Back</button>
          </div>
          <div class="col-md-2 padding-left-0px padding-right-24px">
            <button class="btn btn-primary hover1 nav-link-hand font-size-16px width float-right" (click)="Confirm()" type="button">Book</button>

          </div>


        </div>
      </div>
    </div>
  </div>

</div>


<div class="card my-profile-form" *ngIf="Registeredpatient">
  <div class="card-header wh-header padding-top-6px padding-bottom-6px">
    <div class="row">
      <div class="col-md-12 padding-left-0px">
        <label class="float-left margin-left-10px">Patients</label>
        <input type="search" class="form-control padding-bottom-2px width-176px margin-left-10px float-right" placeholder="Search....">
      </div>

    </div>

  </div>
  <div class="card-body padding-top-0px">

    <div class="table-component">
      <div class="table-responsive overflow-x">


        <table class="table table-striped margin-left-zero"
               cols="auto,2*,*,*,*,*,*,*">

          <thead class="">
            <tr>

              <th>
                PID
              </th>


              <th class="">
                Name
              </th>
              <th class="">
                Reg date
              </th>

              <th class="">
                Age
              </th>

              <th class="">
                Sex
              </th>
              <th class="">
                Phone Number
              </th>
              <th class="">
                Email
              </th>
              <th class="">

              </th>

            </tr>
          </thead>

          <tbody class="table-body">
            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>

            <tr>

              <td>1024</td>
              <td class="">B.Vikram Adithya</td>
              <td>
                24-05-2019
              </td>
              <td>45 Years</td>
              <td>Male</td>
              <td>8801667136</td>
              <td>vikramadithya&#64;healins.com</td>
              <td><a (click)="regconfirm()"> <i class="fas fa-check-square font-size-30px g nav-link-hand"></i></a></td>
            </tr>




          </tbody>

        </table>
      </div>
    </div>
  </div>
</div>


<div class="row margin-top-15px margin-right-0px" *ngIf="Regconfirm">
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="offset-md-1 col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="offset-md-3 col-md-9 padh1">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">24-May-2019</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">11:15 A.M</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px">B.Vikram Adithya</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">Male, 45 Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 8801667136</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : vikramadithya&#64;healins.com</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>


            <div class="offset-md-3 col-md-9 padding-left-0px">
              <div class="row">
                <div class="offset-md-3 col-md-9">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width margin-top-30px margin-left-45px" (click)="Confirm1()" type="button">Book</button>

                </div>



              </div>
            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>


<div class="row margin-top-15px margin-right-0px" *ngIf="Final1">
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="offset-md-1 col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="offset-md-3 col-md-9 padh1">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">24-May-2019</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">11:15 A.M</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px">B.Vikram Adithya</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">Male, 45 Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 8801667136</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : vikramadithya&#64;healins.com</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div class="offset-md-4 col-md-8 padding-left-0px">

              <div class="row">
                <label class="font-size-20px margin-left-22px margin-top-30px margin-bottom-20px"><i class="fas fa-check-circle font-size-30px g"></i> Appointment is Booked Successfully !</label>
              </div>

            </div>
            <div class="offset-md-3 col-md-9 padding-left-0px">
              <div class="row">
                <div class="offset-md-4 col-md-3">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width margin-top-10" (click)="BacktoList1()" type="button">Done</button>

                </div>



              </div>
            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>


<div class="row margin-top-15px margin-right-0px" *ngIf="Final">
  <div class="offset-md-2 col-md-8 S1 padding-right-0px background-white">
    <div class="card">
      <div class="card-header background-white pad1">
        <div class="row margin-bottom-8px">
          <div class="offset-md-1 col-md-2">
            <div class="row">
              <a class="user-image-circle-65px">
                <img class="img1" src="DR SITARAM.jpg">
              </a>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row a1">
              <label class="margin-bottom-0px f2">Dr.Sitharam</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">DM, MD, MBBS</label>
            </div>
            <div class="row a1">
              <label class="margin-bottom-0px f3">Cardiologist</label>
            </div>

          </div>

        </div>


      </div>

      <div class="card-body background-white padding-left-0px padding-top-0px">


        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px margin-bottom-10px">

          <div class="row">
            <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px c3">
              <div class="row">
                <div class="offset-md-3 col-md-9 padh1">

                  <div class="row">

                    <div class="col-md-4">
                      <div class="row a1">
                        <label class="margin-bottom-0px f2">Appointment</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-0px">24-May-2019</label>
                      </div>
                      <div class="row a1">
                        <label class="margin-bottom-5px">11:15 A.M</label>
                      </div>
                    </div>

                    <div class="col-md-4 paddin-left-5px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px">B.Vikram Adithya</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px">Male, 45 Years</label>
                      </div>
                    </div>

                    <div class="col-md-4 padding-left-0px">
                      <div class="row">
                        <label class="margin-bottom-0px f2">Patient Contact</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-0px"><i class="fas fa-phone"></i> : 8801667136</label>
                      </div>
                      <div class="row">
                        <label class="margin-bottom-5px"><i class="fas fa-envelope"></i> : vikramadithya&#64;healins.com</label>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

            <div class="offset-md-4 col-md-8 padding-left-0px">

              <div class="row">
                <label class="font-size-20px margin-left-22px margin-top-30px margin-bottom-20px"><i class="fas fa-check-circle font-size-30px g"></i> Appointment is Booked Successfully !</label>
              </div>

            </div>
            <div class="offset-md-3 col-md-9 padding-left-0px">
              <div class="row">
                <div class="offset-md-4 col-md-3">
                  <button class="btn btn-primary hover1 nav-link-hand font-size-16px width margin-top-10" (click)="BacktoList1()" type="button">Done</button>

                </div>



              </div>
            </div>




          </div>

        </div>
      </div>
    </div>

  </div>

</div>
